import { render, staticRenderFns } from "./AppFormTextEditorItn.vue?vue&type=template&id=4ebf1e14&scoped=true&"
import script from "./AppFormTextEditorItn.vue?vue&type=script&lang=js&"
export * from "./AppFormTextEditorItn.vue?vue&type=script&lang=js&"
import style0 from "./AppFormTextEditorItn.vue?vue&type=style&index=0&id=4ebf1e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf1e14",
  null
  
)

export default component.exports